function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "40px",
    height: "40px",
    viewBox: "0 2 20 20",
    id: "rope",
    "data-name": "Flat Line",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon flat-line",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M10,11C8.34,11,7,7.66,7,6a3,3,0,0,1,6,0C13,7.66,11.66,11,10,11Zm0,2c-1.66,0-3,3.34-3,5a3,3,0,0,0,6,0C13,16.34,11.66,13,10,13ZM7,10h6M6,12h8m4,4h0a6.84,6.84,0,0,0-4.83-2H7",
    style: {
      fill: "none",
      stroke: "#1E81F7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRope);
export default __webpack_public_path__ + "static/media/rope.42945122a413896be145d16d5146cb28.svg";
export { ForwardRef as ReactComponent };